export default __webpack_public_path__ + "static/media/MedalGroup.7b4ec849.png";